<md-product-card-list
    *ngIf="customersAlsoViewed?.length > 0"
    [productEntries]="customersAlsoViewed"
    [title]="'Customers also viewed' | translate"
    (dealSelected)="onDealSelected($event)"
></md-product-card-list>
